// @generated by protoc-gen-es v1.10.0
// @generated from file ai/h2o/mlops/deployer/v1/kubernetes_resource_spec.proto (package ai.h2o.deploy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * Represents Kubernetes resource specifications passed directly to Kubernetes.
 *
 * @generated from message ai.h2o.deploy.KubernetesResourceSpec
 */
export const KubernetesResourceSpec = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.KubernetesResourceSpec",
  () => [
    { no: 1, name: "kubernetes_resource_requirement", kind: "message", T: KubernetesResourceRequirement },
    { no: 2, name: "replicas", kind: "scalar", T: 5 /* ScalarType.INT32 */, opt: true },
  ],
);

/**
 * Represents compute resource requirements for Kubernetes. Reflects Kubernetes'
 * ResourceRequirements v1 API.
 *
 * More info: https://kubernetes.io/docs/concepts/configuration/manage-resources-containers/
 *
 * @generated from message ai.h2o.deploy.KubernetesResourceRequirement
 */
export const KubernetesResourceRequirement = /*@__PURE__*/ proto3.makeMessageType(
  "ai.h2o.deploy.KubernetesResourceRequirement",
  () => [
    { no: 1, name: "limits", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
    { no: 2, name: "requests", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "scalar", T: 9 /* ScalarType.STRING */} },
  ],
);

